export default {
  name: 'marking--eanInfoUpload',
  apiService: 'shoes',
  apiPath: '/admin/ean_info/func/upload',
  urlParamName: 'marking--eanInfoUpload',
};